export function formatDate(date) {
  const dtf = new Intl.DateTimeFormat('fr', { year: 'numeric', month: '2-digit', day: '2-digit' });
  return dtf.format(new Date(date));
}

export function formatNumber(num) {
  return new Intl.NumberFormat('fr-FR').format(num);
}
